import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";

function StatusHistoryIcon({ icon, alt, onClick, disabled, tooltipTitle }) {
	return (
		<Tooltip arrow title={tooltipTitle}>
			<span>
				<button className="!bg-transparent !cursor-pointer !border-none" onClick={onClick} disabled={disabled || false}>
					<img src={icon} alt={alt} className="w-[15px] h-[18px]" />
				</button>
			</span>
		</Tooltip>
	);
}

StatusHistoryIcon.propTypes = {
	icon: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	tooltipTitle: PropTypes.string,
};

export default StatusHistoryIcon;
